import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fca235a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fca235a')) {
      api.createRecord('3fca235a', component.options)
    } else {
      api.reload('3fca235a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fca235a&", function () {
      api.rerender('3fca235a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/menu/index.vue"
export default component.exports